import styled from 'styled-components';
import { hexa } from 'styles/utils';

import Badge from 'components/Badge';

export const PhaseBadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BadgeStyled = styled(Badge)`
  padding: ${props =>
    `${props.theme.spacing.small} ${props.theme.spacing.medium}`};
  margin: auto ${props => props.theme.spacing.default} auto 0;
  height: fit-content;
  border-radius: 0;
  color: ${props => props.customBgColor};
  border: 1px solid currentColor;
  background-color: ${props =>
    props.customBgColor && hexa(props.customBgColor, 0.3)};
  font-weight: ${props => props.theme.font.weight.regular};
  cursor: default;
`;

export const ButtonWrapper = styled.div`
  display: block;
  margin: ${props => props.theme.spacing.default} auto;
`;
